module.exports = __webpack_public_path__ + "static/img/28.12a62d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/28.png
// module id = B+9h
// module chunks = 1